import { httpCreate } from './http';

const http = httpCreate('/srv/flux-storage-space');

export const fluxStorageSpace = {
	getTotalFlux(params) {
		return http.get('/totalFlux', { params, ttl: 1000 });
	},
	getFlowList(params) {
		return http.get('', { params });
	},
};
